// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/ForgotPassword.css
// module id = 1764
// module chunks = 0